<template>
  <div class="card">
    <div class="card-content">
      <div class="pull-right" style="position:relative;z-index:2">
        <a class="btn btn-info"  @click.prevent="goToAdd"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('settingUsers.single')}}</a>
      </div>
      <data-tables 
            v-loading="loading"
            :data="tableData"
            :search-def="{}"
            :pagination-def="{}"
            :table-props="{'border': false}"
            @row-click="goToRecord"
            style="width: 100%">
        <el-table-column v-for="column in tableColumns"
                         :key="column.label"
                         :min-width="column.minWidth"
                         :prop="column.prop"
                         :label="column.label"
                         sortable>
        </el-table-column> 
        <el-table-column
              :width="45">
          <template slot-scope="props"><i class="fa fa-pencil"></i></template>
        </el-table-column>
      </data-tables>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      [Input.name]: Input
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      }
    },
    created: function () {
      this.getData()
    },
    data () {
      return {
        loading: true,
        tableColumns: [
          {
            prop: 'firstname',
            label: this.$t('settingUsers.fn'),
            minWidth: 100
          },
          {
            prop: 'lastname',
            label: this.$t('settingUsers.ln'),
            minWidth: 100
          },
          {
            prop: 'role',
            label: this.$t('settingUsers.role'),
            minWidth: 150
          }
        ],
        tableData: []
      }
    },
    methods: {
      goToRecord (row, event, column) {
        if (typeof this.callback === 'function') {
          this.callback(row.id)
        } else {
          this.globalGoToRecord(row, event, column, '/user/edit/')
        }
      },
      getData () {
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/profile', 'GET', data, function (response) {
          if (response.status === true) {
            self.tableData = response.data

            self.$nextTick(function () {
              self.loading = false
            })
          }
        })
      },
      goToAdd () {
        if (typeof this.callback === 'function') {
          this.callback(null)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Users/Users.vue